import styles from "./Table.module.css";
import DateTimeHelper from "../../../core/helpers/dateTimeHelper";

export const TableDateCell = ({ value }: { value: Date }) => (
  <span className={`${styles.tableCell} ${styles.tableDateCell}`}>
    {value ? DateTimeHelper.formatDateTime(value) : null}
  </span>
);
export default TableDateCell;
